import type { DynamicFieldComponentProps } from '@myosh/odin-components';
import type { ExportRecordFieldFormat } from '../../../@types/records';
import { useAppDispatch } from '../../../redux/hooks';
import { submitExportRecordFieldJob } from '../../../redux/slices/background-job-slice';
import WrapperStyledButtonField from '../../common/wrapper-styled-button-field';

export interface ExportButtonFieldProps extends DynamicFieldComponentProps<unknown> {
  buttonCaption?: string;
  fieldType?: ExportRecordFieldFormat;
  recordId?: number;
}

function ExportButtonField({ id, buttonCaption, recordId, fieldType, readOnly }: ExportButtonFieldProps) {
  const dispatch = useAppDispatch();

  const onClick = () => {
    if (id && recordId && fieldType) {
      dispatch(submitExportRecordFieldJob({ recordId: recordId, fieldId: Number(id), format: fieldType }));
    }
  };

  return (
    <WrapperStyledButtonField onClick={onClick} disabled={readOnly} buttonCaption={buttonCaption} icon="FileText" />
  );
}

export default ExportButtonField;
